import { Tooltip, TooltipProps } from '@mui/material';
import { ReactElement } from 'react';

interface props {
  tooltip: boolean;
  text: string;
  children: ReactElement;
  placement?: TooltipProps['placement'];
  displayAsBlock?: boolean;
}
const ToolTipContent = ({
  tooltip,
  children,
  text,
  placement,
  displayAsBlock
}: props) => {
  return tooltip ? (
    <Tooltip title={text} placement={placement ?? 'top'}>
      <div
        role={'tooltip'}
        style={{ display: displayAsBlock ? 'block' : 'inline-block' }}
      >
        {children}
      </div>
    </Tooltip>
  ) : (
    <>{children}</>
  );
};
export default ToolTipContent;
